import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { browserStorage } from 'Redux/services/storage'
import { SL_GATE } from 'Defaults/modals'
import ArchiveListings, { perPageCalc } from 'Components/ArchiveListings/ArchiveListingsApiContainer'
import { useFetchArchiveListings } from 'Components/ArchiveListings/archiveListingsApis'

import AppLinkMobileCtrl from 'Components/AppLinkMobileCtrl'
import ToTopOnMount from 'Components/ToTopOnMount'
import StaticMetaTags from 'Components/StaticMetaTags'
import { BuildingV2 } from 'Pages'
import SvgIcon from 'Components/SvgIcon'

import {
  _ArchiveListings, _Title, _TitleLink, _Address, _RootContainer,
  _BackBtnContainer, _TopBanner, _MaxWidthContainer,
  _TitleContainer,
} from './styles'

const bs = browserStorage()

export const PRICE_HISTORY_PAGE = 'Price history page'

const ArchiveListingsPage = (props) => {
  const {
    lastSearchObj, archiveMobileModalPageData, isMobileApp, closeModalPage,
    userIsAuthentificated, openRegisterModal, mobileBrowser,
  } = props
  const [clientSideRendered, setClientSide] = useState(false)
  const { addressId, suiteNumber, buildingId, bedTypeNum, offer } = archiveMobileModalPageData || lastSearchObj

  useEffect(() => {
    setClientSide(true)
  }, [])
  useEffect(() => {
    if(!userIsAuthentificated && clientSideRendered) {
      openRegisterModal({
        modalData: { gate: SL_GATE.PAST_LISTING },
      })
    }
  }, [userIsAuthentificated, clientSideRendered])

  const perPage = perPageCalc({
    buildingId,
    suiteNumber,
    addressId,
    isArchiveListingsPage: true,
    mobileBrowser,
  })

  const { data: archiveListingsData } = useFetchArchiveListings({
    id: buildingId || addressId,
    component: buildingId ? 'building' : 'address',
    token: bs.token,
    payload: {
      addressId,
      suiteNumber,
      buildingId,
      bedTypeNum,
      offer,
      bedTypeCategory: 1,
      perPage,
    },
  })

  const renderPageTitle = (data) => {
    if(data) {
      const buildingUrl = '/' + data.url
      const Elem = buildingUrl ? AppLinkMobileCtrl : 'div'
      const buildingAddress = data.building_address
      return (
        <_TitleContainer isMobileApp={isMobileApp}>
          <_Title>
            <_TitleLink
              as={Elem}
              to={buildingUrl || ''}
              hasUrl={buildingUrl}
              mobileModalChildren={
                // eslint-disable-next-line react/no-unstable-nested-components
                ({ closeModalPage: closeModalPageHandle }) => (
                  <BuildingV2
                    buildingId={data.building_id}
                    closeModalPage={closeModalPageHandle}
                  />
                )
              }
              mobileModalKey={`buildingModal-${data.building_id}`}
            >
              {data.title}
            </_TitleLink>
            <span>&nbsp;Listing History</span>
          </_Title>
          {
            buildingAddress && (
              <_Address>
                View previously sold or rented units at {buildingAddress} ({archiveListingsData.title})
              </_Address>
            )
          }
        </_TitleContainer>
      )
    }
  }

  return (
    <_RootContainer id="heap-ArchivedListings" tabIndex="-1" isMobileApp={isMobileApp}>
      <_TopBanner isMobileApp={isMobileApp}>
        {isMobileApp && (
          <_BackBtnContainer onClick={closeModalPage}>
            <SvgIcon name="#icon-arrow-final" width={10} height={23} />
          </_BackBtnContainer>
        )
        }
        <ToTopOnMount />
        <StaticMetaTags
          title={`${archiveListingsData ? archiveListingsData.title : ''} - Past Listings`}
        />
        {renderPageTitle(archiveListingsData)}
      </_TopBanner>
      <_MaxWidthContainer>
        <_ArchiveListings isMobileApp={isMobileApp}>
          <ArchiveListings
            enableLoadMore
            pageFrom={PRICE_HISTORY_PAGE}
            userIsAuthentificated={userIsAuthentificated}
            addressId={addressId}
            buildingId={buildingId}
            suiteNumber={suiteNumber}
            bedTypeNum={bedTypeNum}
            offer={offer}
            isArchiveListingsPage
          />
        </_ArchiveListings>
      </_MaxWidthContainer>
    </_RootContainer>
  )
}

ArchiveListingsPage.propTypes = {
  lastSearchObj: PropTypes.shape({
    addressId: PropTypes.string,
    buildingId: PropTypes.string,
    suiteNumber: PropTypes.number,
    bedTypeNum: PropTypes.string,
    offer: PropTypes.string,
  }),
  archiveMobileModalPageData: PropTypes.shape({
    addressId: PropTypes.number,
    buildingId: PropTypes.number,
    suiteNumber: PropTypes.string,
    bedTypeNum: PropTypes.string,
    offer: PropTypes.string,
  }),
  userIsAuthentificated: PropTypes.bool,
  openRegisterModal: PropTypes.func,
  archiveListingsData: PropTypes.shape({
    title: PropTypes.string,
    building_address: PropTypes.string,
  }),
  isMobileApp: PropTypes.bool,
  mobileBrowser: PropTypes.bool,
  closeModalPage: PropTypes.func,
}

export default ArchiveListingsPage
